import { render, staticRenderFns } from "./Consultorio.vue?vue&type=template&id=ddec9a10&scoped=true"
import script from "./Consultorio.vue?vue&type=script&lang=js"
export * from "./Consultorio.vue?vue&type=script&lang=js"
import style0 from "./Consultorio.vue?vue&type=style&index=0&id=ddec9a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddec9a10",
  null
  
)

export default component.exports